const BEE_MAPS_URL = 'https://www.beemaps.com';
const BEE_MAPS_LOGIN_URL = 'https://beemaps.com/login';
const HIVEMAPPER_DOCS_URL = 'https://docs.hivemapper.com/';
const WHAT_IS_HONEY_URL =
  'https://docs.hivemapper.com/honey-token/what-is-honey';

const externalUrls = {
  PurchaseDashcam:
    'https://hivemapper.myshopify.com/collections/frontpage/products/blackvue-dr900s-1ch-4k-dashcam-1-channel-128gb-sd-card',
  Docs: 'https://docs.hivemapper.com/',
  ContributeGuide: 'https://docs.hivemapper.com/start-mapping/driving',
  ContributeWithDashcam: 'https://docs.hivemapper.com/contribute/dashcam',
  MapApi: 'https://docs.hivemapper.com/main-concepts/map-image-api',
  Upload: 'https://docs.hivemapper.com/contribute/dashcam/5-upload-content',
  PreOrder: 'https://shop.hivemapper.com/',
  CryptoToken: 'https://coinmarketcap.com/currencies/solana/',
  HivemapperWeb: 'https://beemaps.com/',
  Dashcam: 'https://beemaps.com/hivemapper-dashcam',
  FAQ: 'https://docs.hivemapper.com/resources/frequently-asked-questions',
  HowItWorks: 'https://beemaps.com/mapping-network#introduction',
  Pricing: 'https://beemaps.com/pricing',
  Honey:
    'https://solscan.io/token/4vMsoUT2BWatFweudnQM1xedRLfJgJ7hswhcpz4xgBTy#analysis',
  Mapbox: 'https://www.mapbox.com/about/maps',
  OSM: 'https://www.openstreetmap.org/copyright',
  ImproveMap: 'https://www.mapbox.com/map-feedback',
  GithubODC: 'https://github.com/hivemapper/odc',
  BuyADashcam:
    'https://shop.hivemapper.com/?utm_source=salebutton&utm_medium=organic&utm_campaign=salebutton&utm_id=1212023',
  AITrainerDocs: 'https://docs.hivemapper.com/start-mapping/train-map-ai',
  BeeDashcamStore: 'https://bee.hivemapper.com/',
  BeeLegalPlacards:
    'https://docs.beemaps.com/help-and-support/data-protection-and-privacy#placards-for-mappers',
  MapWithPhone: 'https://docs.hivemapper.com/start-mapping/map-with-phone',
  MapDataConsole: 'https://docs.hivemapper.com/use-the-map/console',
  ScoutDocs: 'https://docs.hivemapper.com/use-the-map/scout',
  Product: 'https://beemaps.com/product',
  VeraSafeWebsite:
    'https://verasafe.com/public-resources/contact-data-protection-representative',
  ProtectionAndPrivacy:
    'https://docs.hivemapper.com/welcome/data-protection-and-privacy',
  ScoutHostedService:
    'https://docs.hivemapper.com/use-the-map/scout/scout-hosted-service',
  MapProducts: 'https://beemaps.com/tos/map-products/#introduction',
  beeMaps: BEE_MAPS_URL,
  beemapsLogin: BEE_MAPS_LOGIN_URL,
  hivemapperDocs: HIVEMAPPER_DOCS_URL,
  whatIsHoney: WHAT_IS_HONEY_URL,
  mediumBlog: 'https://medium.com/@hivemapper',
  scout: 'https://beemaps.com/scout',
};

const socialUrls = {
  x: 'https://x.com/hivemapper',
};

const routes = {
  home: '/',
  tos: '/tos',
  network: {
    regions: '/network/regions',
    contributors: '/network/contributors',
  },
  coverage: '/coverage',
  privacy: {
    overview: '/privacy/overview',
    privacyPolicy: '/privacy/privacy-policy',
    redactionRequest: '/privacy/redaction-request',
  },
};

export {
  routes,
  socialUrls,
  externalUrls,
  BEE_MAPS_URL,
  BEE_MAPS_LOGIN_URL,
  HIVEMAPPER_DOCS_URL,
  WHAT_IS_HONEY_URL,
};
